import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

// Eine Suche über Kinder, Warteliste, Kontaktanfragen, Probetrainings und Gruppen.
// Vorher musste man wissen, in welcher Liste jemand steht.
const SYMBOLE = {
  schwimmer: '👶', warteliste: '≡', kontakt: '✉', probetraining: '◎', gruppe: '🏊',
};
const BEREICHE = {
  schwimmer: 'Schwimmer', warteliste: 'Warteliste', kontakt: 'Kontaktanfrage',
  probetraining: 'Probetraining', gruppe: 'Gruppe',
};

export default function GlobaleSuche() {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [treffer, setTreffer] = useState([]);
  const [offen, setOffen] = useState(false);
  const [laedt, setLaedt] = useState(false);
  const [aktiv, setAktiv] = useState(0);
  const huelle = useRef(null);
  const feld = useRef(null);

  // Tastenkürzel: Strg/Cmd + K
  useEffect(() => {
    const taste = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        feld.current?.focus();
      }
    };
    window.addEventListener('keydown', taste);
    return () => window.removeEventListener('keydown', taste);
  }, []);

  // Klick außerhalb schließt die Liste
  useEffect(() => {
    const klick = (e) => { if (huelle.current && !huelle.current.contains(e.target)) setOffen(false); };
    document.addEventListener('mousedown', klick);
    return () => document.removeEventListener('mousedown', klick);
  }, []);

  const suchen = useCallback(async (q) => {
    if (q.trim().length < 2) { setTreffer([]); return; }
    setLaedt(true);
    try {
      const r = await api.get('/api/admin/suche', { params: { q } });
      setTreffer(r.data.treffer || []);
      setAktiv(0);
    } catch { setTreffer([]); }
    finally { setLaedt(false); }
  }, []);

  // Erst tippen lassen, dann fragen
  useEffect(() => {
    const t = window.setTimeout(() => suchen(text), 250);
    return () => window.clearTimeout(t);
  }, [text, suchen]);

  const oeffnen = (t) => {
    setOffen(false); setText('');
    navigate(t.pfad);
  };

  const taste = (e) => {
    if (!offen || !treffer.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setAktiv(i => (i + 1) % treffer.length); }
    if (e.key === 'ArrowUp') { e.preventDefault(); setAktiv(i => (i - 1 + treffer.length) % treffer.length); }
    if (e.key === 'Enter') { e.preventDefault(); oeffnen(treffer[aktiv]); }
    if (e.key === 'Escape') setOffen(false);
  };

  return (
    <div ref={huelle} className="globale-suche">
      <input
        ref={feld}
        type="search"
        value={text}
        onChange={e => { setText(e.target.value); setOffen(true); }}
        onFocus={() => setOffen(true)}
        onKeyDown={taste}
        placeholder="Suchen … (Strg+K)"
        aria-label="Kind, Kontakt oder Gruppe suchen"
      />
      {offen && text.trim().length >= 2 && (
        <div className="globale-suche-liste">
          {laedt && treffer.length === 0 && <div className="globale-suche-leer">Suche …</div>}
          {!laedt && treffer.length === 0 && <div className="globale-suche-leer">Nichts gefunden</div>}
          {treffer.map((t, i) => (
            <button key={`${t.art}-${t.id}`} type="button"
              onMouseEnter={() => setAktiv(i)}
              onClick={() => oeffnen(t)}
              className={`globale-suche-treffer${i === aktiv ? ' aktiv' : ''}`}>
              <span className="globale-suche-symbol">{SYMBOLE[t.art] || '•'}</span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className="globale-suche-titel">{t.titel}</span>
                <span className="globale-suche-zusatz">{t.zusatz}</span>
              </span>
              <span className="globale-suche-bereich">{BEREICHE[t.art] || t.art}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
